const getFirstName = (name: string) => name.split(/\s+/).shift();

export default getFirstName;
